import React from 'react';
 
const Test = () => {
  return (
<div className="min-h-screen bg-white text-center font-sans">
      {/* Top Image with curve */}
<div className="relative">
<img
          src="/path/to/your/chicken-image.jpg"
          alt="Delicious Food"
          className="w-full h-64 object-cover"
        />
        {/* Curved bottom using SVG */}
<svg
          className="absolute bottom-0 w-full"
          viewBox="0 0 1440 100"
          xmlns="http://www.w3.org/2000/svg"
>
<path
            fill="white"
            d="M0,0 C360,100 1080,0 1440,100 L1440,0 L0,0 Z"
          />
</svg>
</div>
 
      {/* Logo */}
<div className="mt-[-30px]">
<img src="/path/to/logo.png" alt="MB Chicken" className="mx-auto w-40" />
</div>
 
      {/* Subtitle */}
<p className="text-lg font-medium text-gray-700 mt-4 mb-6">Choose your order type</p>
 
      {/* Buttons */}
<div className="flex justify-center gap-6 px-6">
<div className="bg-blue-100 p-6 rounded-lg w-36 cursor-pointer hover:shadow-lg">
<img src="/icons/takeaway-icon.png" alt="Takeaway" className="mx-auto h-10 mb-2" />
<p className="text-blue-600 font-semibold">Take Away</p>
</div>
<div className="bg-blue-100 p-6 rounded-lg w-36 cursor-pointer hover:shadow-lg">
<img src="/icons/eatin-icon.png" alt="Eat In" className="mx-auto h-10 mb-2" />
<p className="text-blue-600 font-semibold">Eat in</p>
</div>
</div>
</div>
  );
};
 
export default Test;